import React from 'react';
import { createRoot } from 'react-dom/client';  // ✅ 关键：使用具名导入
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// 找到 HTML 里的 #root 容器
const container = document.getElementById('root');

// 创建 React 渲染根节点
const root = createRoot(container);

// 渲染 App 组件
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// 性能报告（可选）
reportWebVitals();